import React from 'react';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Experience } from './components/Experience';
import { Community } from './components/Community';
import { Visit } from './components/Visit';
import { Footer } from './components/Footer';
export function App() {
  return <div className="bg-black text-white w-full min-h-screen" data-id="element-0">
      <Hero data-id="element-1" />
      <About data-id="element-2" />
      <Experience data-id="element-3" />
      <Community data-id="element-4" />
      <Visit data-id="element-5" />
      <Footer data-id="element-6" />
    </div>;
}